import {MonthColumns, MonthDataColumns} from '../types'

export const MONTH_MAP: Record<string, keyof MonthDataColumns[string]> = {
  '01': 'jan',
  '02': 'feb',
  '03': 'mar',
  '04': 'apr',
  '05': 'may',
  '06': 'jun',
  '07': 'jul',
  '08': 'aug',
  '09': 'sep',
  '10': 'oct',
  '11': 'nov',
  '12': 'dec'
}

export const monthMapStringToDigit: Record<keyof MonthColumns, string> = {
  jan: '01',
  feb: '02',
  mar: '03',
  apr: '04',
  may: '05',
  jun: '06',
  jul: '07',
  aug: '08',
  sep: '09',
  oct: '10',
  nov: '11',
  dec: '12'
}

export const MONTH_REVERSE_MAP = Object.fromEntries(
  Object.entries(MONTH_MAP).map(([key, value]) => [value, key])
) as Record<keyof (typeof MONTH_MAP)[keyof typeof MONTH_MAP], keyof typeof MONTH_MAP>

export const MIN_VALUE = 0
export const MAX_VALUE = 100

// 5 seconds
export const DIRTY_POLL_INTERVAL = 5000
